import React, { memo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { safePost } from '../../../../axios-default';
import { easySnackbar } from '../../../../store/Noti/noti.actions';
import PercentageProgressRing from '../../../../components/PercentageProgressRing';
import UpdateCaseTypeModal from '../../../../components/Modal/UpdateCaseTypeModal';
import useTreatmentOptionForTpApproval from '../../../../hooks/useTreatmentOptionForTpApproval';
import { ClinicalApprovementOption } from '../../clinicalApprovementOptionConstants';
import { useLang } from '../../../../util/lang';

const UpgradeTreatmentPlanModal = ({ openExtenal, setOpenExtenal, planId, caseId }) => {
    const progressBarRef = useRef(null);
    const get = useLang();
    const dispatch = useDispatch();
    const clinicalSimulationCase = useSelector((state) => state.clinicalSimulation.patientInfoData);
    const planIdinMultiplePlan = useSelector((state) => state.smileDesign.planId);
    const [isLoading, setIsLoading] = useState(false);

    const currentPlanId = planId === undefined ? planIdinMultiplePlan : planId;
    const currentCaseId = caseId === undefined ? clinicalSimulationCase?.case_id : caseId;
    const { productMatrixArray, defaultCaseType, isFetchingProductmatrixForDr, optionSelected, setOptionSelected } =
        useTreatmentOptionForTpApproval({
            caseId: currentCaseId,
            planId: currentPlanId,
            openExternal: openExtenal,
        });

    const onSubmit = async (approveMode) => {
        try {
            const selectedOption = approveMode === 'approve_current' ? defaultCaseType : optionSelected;
            const body = {
                approvementOption: ClinicalApprovementOption[1],
                upgradeOption: {
                    allowUpgrade: approveMode === 'upgrade',
                    case_type: selectedOption['case_type'],
                    case_type_id: selectedOption['case_type_id'],
                },
                defaultCaseTypeId: defaultCaseType['case_type_id'],
            };
            setIsLoading(true);
            const result = await safePost(
                `/case/smileDesign/approveIDesignAligner/${currentCaseId}/${currentPlanId}`,
                body,
                {
                    onUploadProgress: progressBarRef.current?.onProgressChange,
                }
            );

            if (result.success) {
                setIsLoading(false);
                dispatch(easySnackbar(get('@PatientInfo.smileDesign.approveIDesignAndSmileDesign'), 'success', true));
                // history.push(`/patients/${currentCaseId}`)
                setTimeout(() => window.location.reload(), 800);
            } else {
                setIsLoading(false);
                dispatch(easySnackbar(`Failed`, 'error'));
            }
        } catch (e) {
            setIsLoading(false);
            dispatch(easySnackbar(e?.response?.data?.message, 'error'));
        }
    };

    return (
        <>
            <PercentageProgressRing ref={progressBarRef} open={isLoading} label={undefined} />

            <UpdateCaseTypeModal
                open={openExtenal}
                handleClose={() => setOpenExtenal(false)}
                handleDataSave={onSubmit}
                optionSelected={optionSelected}
                setOptionSelected={setOptionSelected}
                productMatrixArray={productMatrixArray}
                isFetchingProductmatrixForDr={isFetchingProductmatrixForDr}
                defaultCaseType={defaultCaseType}
                isAllowEscapeTreatmentPlanApproval
            />
        </>
    );
};

export default memo(UpgradeTreatmentPlanModal);
